let TCMDiagnosis = function (tokenClient, serviceAddr) {
    let TokenClient = tokenClient;
    let ServiceBaseAddress = serviceAddr;

    /**
     * 获取中医诊断分类
     * @param {any} success
     * @param {any} error
     */
    this.TCMDiagnosis = function (success, error) {
        var url = ServiceBaseAddress + '/api/TCMDiagnosis/Categories';
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }

    /**
     * 获取中医诊断详情
     * @param {any} success
     * @param {any} error
     */
    this.Detail = function (params,success, error) {
        var url = ServiceBaseAddress + '/api/TCMDiagnosis/Dialectical/' + params;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
}

export { TCMDiagnosis }
